module.exports = __webpack_public_path__ + "img/4_diamonds_star.b6d70af4.png";